import styled from "styled-components";
import { colors } from "../../../../../../../../shared/styled/varibles";

export const PlayerContainerSC = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 10px;
    gap: 8px;
    background: ${colors.bgMenu};
    border-radius: 8px;
`;

export const TimeDisplaySC = styled.div`
    font-family: "Inter";
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 160%;
    letter-spacing: -0.01em;
    color: ${colors.textColor};
`;

export const WaveTimeWrapperSC = styled.div``;

export const WaveformContainerSC = styled.div`
    flex: 1;
    //min-width: 200px;
    cursor: pointer;
    height: 1.7rem;

    /* Style the waveform canvas */
    wave {
        overflow: hidden !important;
    }
`;

export const PlayButtonSC = styled.button<{ $isPlaying: boolean }>`
    width: 44px;
    height: 44px;
    border-radius: 50%;
    background: ${colors.bluishGray};
    border: none;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s ease;
    flex-shrink: 0;

    &:hover {
        background: #b5c4df;
        transform: scale(1.05);
    }

    &:active {
        transform: scale(0.95);
    }

    &:disabled {
        opacity: 0.5;
        cursor: not-allowed;
    }

    svg {
        width: 16px;
        height: 16px;
        fill: white;
        margin-left: ${(props) => (props.$isPlaying ? "0" : "2px")};
    }
`;
